module.exports = __webpack_public_path__ + "static/3i-6725c3fb1f3abd7ebdcb2d244758f706.woff2";